var map = {
	"./Add.svg": 113,
	"./Check.svg": 842,
	"./Combined Shape.svg": 843,
	"./add_black.svg": 451,
	"./add_blue.svg": 844,
	"./add_white.svg": 410,
	"./afgewerkt_color.svg": 845,
	"./afgewerkt_white.svg": 846,
	"./alert.svg": 61,
	"./all_icon_color.svg": 259,
	"./all_icon_white.svg": 353,
	"./arrow.svg": 847,
	"./arrow_down_grey.svg": 68,
	"./arrow_left.svg": 136,
	"./arrow_left_blue.svg": 171,
	"./arrow_right.svg": 140,
	"./arrow_right_standard.svg": 139,
	"./arrow_right_white.svg": 166,
	"./arrow_up.svg": 354,
	"./arrow_up_grey.svg": 186,
	"./attachment.svg": 206,
	"./badge.svg": 848,
	"./behandeling.svg": 849,
	"./bell.svg": 342,
	"./betaald_color.svg": 256,
	"./betaald_white.svg": 350,
	"./business-and-trade-gray.svg": 287,
	"./business-and-trade.svg": 290,
	"./button_check.svg": 209,
	"./button_edit.svg": 406,
	"./cancel.svg": 258,
	"./cancel_white.svg": 352,
	"./change.svg": 850,
	"./chat.svg": 411,
	"./check.svg": 851,
	"./check_blue.svg": 178,
	"./check_green (copy).svg": 852,
	"./check_green.svg": 254,
	"./check_grey.svg": 187,
	"./check_white.svg": 116,
	"./corner.png": 41,
	"./correct.svg": 288,
	"./cross.svg": 67,
	"./cross_white.svg": 183,
	"./dots.svg": 853,
	"./down_arrow.svg": 193,
	"./download.svg": 87,
	"./download_grey.svg": 100,
	"./edit.svg": 854,
	"./edit_blue.svg": 114,
	"./emoji.svg": 205,
	"./factuur.svg": 220,
	"./geannuleerd_color.svg": 855,
	"./geannuleerd_white.svg": 856,
	"./gefactureerd_color.svg": 255,
	"./gefactureerd_white.svg": 349,
	"./glass.svg": 289,
	"./glass_grey.svg": 123,
	"./google-docs.svg": 412,
	"./hold_color.svg": 857,
	"./hold_white.svg": 858,
	"./icon_bluilding_mixedblue.svg": 859,
	"./icon_chat_darkgrey.svg": 249,
	"./icon_folder_darkgrey.svg": 248,
	"./icon_search_blue.svg": 860,
	"./icon_search_blue_dark.svg": 405,
	"./info.svg": 62,
	"./info_circle_blue.svg": 225,
	"./info_circle_grey.svg": 317,
	"./invoice.pdf": 861,
	"./load.svg": 253,
	"./load_white.svg": 348,
	"./loader.svg": 250,
	"./loader_white.svg": 345,
	"./loading.gif": 69,
	"./menu.svg": 343,
	"./notification.svg": 862,
	"./offerte_color.svg": 251,
	"./offerte_white.svg": 346,
	"./offerteaanvaard_color.svg": 252,
	"./offerteaanvaard_white.svg": 347,
	"./onhold.svg": 257,
	"./onhold_white.svg": 351,
	"./ontvangen_color.svg": 863,
	"./ontvangen_white.svg": 864,
	"./profile_image.svg": 865,
	"./search.svg": 355,
	"./send.svg": 207,
	"./timeline.svg": 408,
	"./trash.svg": 79,
	"./trash_grey.svg": 315,
	"./upload.svg": 117,
	"./user.svg": 341,
	"./view.svg": 152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;